<div *ngIf="!!loadingFillterData">
    <app-base-report
      *ngIf="prividerReconciliationData"
      [hasDateRangeFilter]="true"
      [hasCheckboxes]="false"
      [reportName]="'Providers Reconciliation Report'"
      [defaultColumns]="properties"
      [columnsDisplayNames]="displayTableColumns"
      [filterFields]="selectFilters"
      [data]="prividerReconciliationData"
      [hasCheckboxes]="true"
      [customSelectionRows]="selectableRows"
      [selectionModel]="selectionModel"
      [selectionActions]="selectionActions"
      (selectionActionTrigger)="selectionActionsCB($event)"
      [rowsLength]="totalNumberOfRecords"
      (filterTrigger)="getCurrentPage($event)"
      (paginationChange)="paginate($event)"
      (searchChange)="searchChange($event)"
      [tableLoading]="loading"
      [hasSort]="true"
      (sortTrigger)="sortChange($event)"
      [serviceInstance]="reconciliationService"
    >
    </app-base-report>
  </div>

